import { hasRole } from './../utils/roles';
import { useAppContext } from './../contexts/AppProvider';
import { matchPath, useLocation } from 'react-router';
import { routes } from 'core/models';

export const useRedirect = (): {
    redirect?: string;
} => {
    const { user, logout } = useAppContext();
    const { pathname } = useLocation();

    const route = routes.find((o) =>
        matchPath(pathname, {
            exact: true,
            path: o.path,
        }),
    );

    if (typeof user.roles.includes !== 'function') {
        logout();
        window.location.reload();
    }

    if (user.roles.includes('ROLE_NEW_INSCRIPTION')) {
        return {};
    }
    if (route && route.role && !hasRole(user, route.role)) {
        return { redirect: '/' };
    }
    if (!route) {
        return { redirect: '/404' };
    }
    return {};
};
